import { GPSSource } from "PosterEditor/model/poster-project";
import { set, get } from "idb-keyval";

export const useGpsStoreLocal = () => {
  const saveCoordinates = async (coordinates: GPSSource, id: string) => {
    try {
      await set(`gps-coordinates-${id}`, coordinates);
    } catch (err) {
      console.error("Failed to save coordinates locally", err);
    }
  };

  const fetchCoordinates = async (id: string): Promise<GPSSource | null> => {
    try {
      const data = await get(`gps-coordinates-${id}`);
      return data ? (data as GPSSource) : null;
    } catch (err) {
      console.error("Failed to load coordinates locally", err);
      return null;
    }
  };

  const deleteCoordinates = async (id: string) => {
    try {
      await set(`gps-coordinates-${id}`, undefined);
    } catch (err) {
      console.error("Failed to delete coordinates locally", err);
    }
  };

  return { saveCoordinates, fetchCoordinates, deleteCoordinates };
};
